import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';

export const TENANT_USERS_TAGS = {
  TENANT_USER: 'TenantUser'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [TENANT_USERS_TAGS.TENANT_USER]
});

export const tenantUsersApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listTenantUsers: build.query({
      async queryFn(args) {
        const {
          indexStart = 0,
          maxResults = 10,
          search = '',
          sortOrder
        } = args || {};

        const params = {
          indexstart: indexStart,
          maxresults: maxResults,
          ...(search ? { search } : {}),
          ...(sortOrder ? { order: sortOrder } : {})
        };

        try {
          const res = await api.TenantUsers.listPaged(params);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      providesTags: [{ type: TENANT_USERS_TAGS.TENANT_USER, id: 'LIST' }]
    }),

    inviteTenantUser: build.mutation({
      async queryFn(args) {
        const { Email, FirstName, LastName, RoleName } = args || {};

        try {
          const res = await api.TenantInvite.invite({
            Email,
            FirstName,
            LastName,
            RoleName
          });
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: TENANT_USERS_TAGS.TENANT_USER, id: 'LIST' }]
    })
  })
});

export const { useListTenantUsersQuery, useInviteTenantUserMutation } =
  tenantUsersApi;
